// import React from "react";
// import { Download, Send, ShieldAlert, Wallet } from "lucide-react";
// import { motion } from "framer-motion";
// import PageHero from "../components/common/PageHero";
// import StatGrid from "../components/common/StatGrid";
// import DataTableCard from "../components/common/DataTableCard";

// export default function Transactions() {
//   return (
//     <div className="erp-page-grid">
//       <PageHero
//         badge="Approval sales"
//         title="A more professional dispatch and settlement experience."
//         subtitle="Approval operations now feel like a premium business app with less clutter, better highlighting and stronger action hierarchy."
//         actions={
//           <>
//             <motion.button
//               className="erp-btn erp-btn-ghost"
//               whileTap={{ scale: 0.97 }}
//             >
//               <Wallet size={15} /> Agent ledger
//             </motion.button>
//             <motion.button
//               className="erp-btn erp-btn-ghost"
//               whileTap={{ scale: 0.97 }}
//             >
//               <Download size={15} /> Dispatch export
//             </motion.button>
//             <motion.button
//               className="erp-btn erp-btn-primary"
//               whileTap={{ scale: 0.97 }}
//             >
//               <Send size={15} /> New dispatch
//             </motion.button>
//           </>
//         }
//       />

//       <StatGrid
//         items={[
//           {
//             title: "Open dispatches",
//             value: "26",
//             meta: "Pending settlement closure",
//             trend: "Watch",
//             tone: "warning",
//             icon: Send,
//           },
//           {
//             title: "Sold quantity",
//             value: "₹4.8L",
//             meta: "Invoice-ready value",
//             trend: "+12%",
//             tone: "success",
//             icon: Wallet,
//           },
//           {
//             title: "Returned quantity",
//             value: "₹2.1L",
//             meta: "Ready for stock recovery",
//             trend: "Track",
//             tone: "neutral",
//             icon: Download,
//           },
//           {
//             title: "Risky agents",
//             value: "2",
//             meta: "High aging or high return tendency",
//             trend: "Review",
//             tone: "warning",
//             icon: ShieldAlert,
//           },
//         ]}
//       />

//       <div className="erp-grid erp-grid-2">
//         <section className="erp-card">
//           <div className="erp-card-head">
//             <div>
//               <h3>Settlement focus</h3>
//               <p>
//                 Keep agent cycles tighter with the few numbers that matter most.
//               </p>
//             </div>
//           </div>
//           <div className="erp-list">
//             {[
//               [
//                 "Agent A",
//                 "Strong sell-through, one partial return pending closure.",
//               ],
//               ["Agent B", "Dispatch aging is rising, follow-up needed today."],
//               [
//                 "Agent C",
//                 "Low risk, excellent recovery speed and cleaner settlement.",
//               ],
//             ].map(([title, text]) => (
//               <div key={title} className="erp-list-row">
//                 <div className="erp-avatar-pill">{title.split(" ")[1]}</div>
//                 <div>
//                   <strong>{title}</strong>
//                   <p>{text}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </section>

//         <section className="erp-card">
//           <div className="erp-card-head">
//             <div>
//               <h3>Commercial readiness</h3>
//               <p>Simple progress cards for dispatch-to-invoice movement.</p>
//             </div>
//           </div>
//           <div className="erp-progress-stack">
//             {[
//               ["Settlement completion", 68, "Most value is moving on time."],
//               [
//                 "Commission reconciliation",
//                 82,
//                 "Only small exceptions remain.",
//               ],
//               [
//                 "Return intake closure",
//                 59,
//                 "Warehouse confirmation still pending.",
//               ],
//             ].map(([title, value, text]) => (
//               <div key={title} className="erp-progress-card">
//                 <div className="erp-progress-top">
//                   <strong>{title}</strong>
//                   <span>{value}%</span>
//                 </div>
//                 <div className="erp-progress-line">
//                   <span style={{ width: `${value}%` }} />
//                 </div>
//                 <p>{text}</p>
//               </div>
//             ))}
//           </div>
//         </section>
//       </div>

//       <DataTableCard
//         title="Approval dispatch / settlement"
//         subtitle="Track dispatch, returns, sold quantity and agent exposure in one clean business table."
//         columns={[
//           { key: "agent", label: "Agent" },
//           { key: "ref", label: "Dispatch Ref" },
//           { key: "qty", label: "Qty" },
//           { key: "sold", label: "Sold" },
//           { key: "returned", label: "Returned" },
//           { key: "status", label: "Status" },
//         ]}
//         rows={[
//           {
//             agent: "Agent A",
//             ref: "AP-1001",
//             qty: "1,200 pcs",
//             sold: "840 pcs",
//             returned: "220 pcs",
//             status: <span className="erp-pill warning">Partial</span>,
//           },
//           {
//             agent: "Agent B",
//             ref: "AP-1002",
//             qty: "600 pcs",
//             sold: "0",
//             returned: "0",
//             status: <span className="erp-pill neutral">Open</span>,
//           },
//           {
//             agent: "Agent C",
//             ref: "AP-1003",
//             qty: "420 pcs",
//             sold: "420 pcs",
//             returned: "0",
//             status: <span className="erp-pill success">Settled</span>,
//           },
//         ]}
//       />
//     </div>
//   );
// }

import React from "react";
import { useSearchParams } from "react-router-dom";

// 👇 pages import karo
import Receipt from "./transactions/Receipt";
import Payment from "./transactions/Payment";
import Cashbook from "./transactions/Cashbook";
import Ledger from "./transactions/Ledger";
import BankStatement from "./transactions/BankStatement";

// 👇 default UI ke liye imports
import { Download, Send, ShieldAlert, Wallet } from "lucide-react";
import { motion } from "framer-motion";
import PageHero from "../components/common/PageHero";
import StatGrid from "../components/common/StatGrid";
import DataTableCard from "../components/common/DataTableCard";
import CreateReceipt from "./transactions/CreateReceipt";
import CreatePayment from "./transactions/CreatePayment";

export default function Transactions() {
  const [searchParams] = useSearchParams();
  const view = searchParams.get("view");

  // 🔥 component mapping
 const componentMap = {
    receipts: <Receipt />,
    "create-receipt": <CreateReceipt />,
    "edit-receipt": <CreateReceipt />,
    payments: <Payment />,
    "create-payment": <CreatePayment />,
    "edit-payment": <CreatePayment />,
    cashbook: <Cashbook />,
    ledger: <Ledger />,
    "bank-statement": <BankStatement />,
  };

  // Exact match
  if (componentMap[view]) {
    return componentMap[view];
  }

  // Receipt create/edit with ID
  if (
    view?.startsWith("create-receipt-") ||
    view?.startsWith("edit-receipt-")
  ) {
    return <CreateReceipt />;
  }

  // Payment create/edit with ID
  if (
    view?.startsWith("create-payment-") ||
    view?.startsWith("edit-payment-")
  ) {
    return <CreatePayment />;
  }

  // 🔥 match view
  if (componentMap[view]) {
    return componentMap[view];
  }

  // 🔥 default dashboard (tumhara existing code)
  return (
    <div className="erp-page-grid">
      <PageHero
        badge="Approval sales"
        title="A more professional dispatch and settlement experience."
        subtitle="Approval operations now feel like a premium business app with less clutter, better highlighting and stronger action hierarchy."
        actions={
          <>
            <motion.button
              className="erp-btn erp-btn-ghost"
              whileTap={{ scale: 0.97 }}
            >
              <Wallet size={15} /> Agent ledger
            </motion.button>

            <motion.button
              className="erp-btn erp-btn-ghost"
              whileTap={{ scale: 0.97 }}
            >
              <Download size={15} /> Dispatch export
            </motion.button>

            <motion.button
              className="erp-btn erp-btn-primary"
              whileTap={{ scale: 0.97 }}
            >
              <Send size={15} /> New dispatch
            </motion.button>
          </>
        }
      />

      <StatGrid
        items={[
          {
            title: "Open dispatches",
            value: "26",
            meta: "Pending settlement closure",
            trend: "Watch",
            tone: "warning",
            icon: Send,
          },
          {
            title: "Sold quantity",
            value: "₹4.8L",
            meta: "Invoice-ready value",
            trend: "+12%",
            tone: "success",
            icon: Wallet,
          },
          {
            title: "Returned quantity",
            value: "₹2.1L",
            meta: "Ready for stock recovery",
            trend: "Track",
            tone: "neutral",
            icon: Download,
          },
          {
            title: "Risky agents",
            value: "2",
            meta: "High aging or high return tendency",
            trend: "Review",
            tone: "warning",
            icon: ShieldAlert,
          },
        ]}
      />

      <DataTableCard
        title="Approval dispatch / settlement"
        subtitle="Track dispatch, returns, sold quantity and agent exposure."
        columns={[
          { key: "agent", label: "Agent" },
          { key: "ref", label: "Dispatch Ref" },
          { key: "qty", label: "Qty" },
          { key: "sold", label: "Sold" },
          { key: "returned", label: "Returned" },
          { key: "status", label: "Status" },
        ]}
        rows={[
          {
            agent: "Agent A",
            ref: "AP-1001",
            qty: "1,200 pcs",
            sold: "840 pcs",
            returned: "220 pcs",
            status: <span className="erp-pill warning">Partial</span>,
          },
        ]}
      />
    </div>
  );
}
